import { boxStyle } from '@/lib/dialogueShots';
import { mediaUrlForPlayback } from '@/lib/mediaUrls';

/**
 * Scene image at its true aspect ratio with each character's box (and optionally the
 * camera framing of a shot) drawn on top. Boxes are 0–1 fractions of the image.
 */
export function CharacterMapOverlay({ imageUrl, characterMap, characterById = {}, highlightId = null, frameRect = null }) {
  const width = Number(characterMap?.width) || 16;
  const height = Number(characterMap?.height) || 9;
  const people = characterMap?.characters || [];
  return (
    <div
      className="relative w-full overflow-hidden rounded-lg"
      style={{ aspectRatio: `${width} / ${height}`, background: 'var(--bg-tertiary)' }}
      data-testid="character-map-overlay"
    >
      {imageUrl ? (
        <img
          src={mediaUrlForPlayback(imageUrl)}
          alt=""
          className="absolute inset-0 w-full h-full"
          style={{ objectFit: 'fill' }}
          draggable={false}
        />
      ) : null}
      {people.map((c) => {
        const active = highlightId && c.character_id === highlightId;
        const name = characterById[c.character_id] || c.name || 'Character';
        return (
          <div
            key={c.character_id}
            className="rounded-md pointer-events-none"
            style={{
              ...boxStyle(c.bbox),
              border: `2px ${c.source === 'fallback' ? 'dashed' : 'solid'} ${active ? '#facc15' : 'rgba(255,255,255,0.85)'}`,
              boxShadow: active ? '0 0 0 2px rgba(0,0,0,0.45)' : 'none',
            }}
          >
            <span
              className="absolute left-0 top-0 px-1.5 py-0.5 text-[10px] font-semibold rounded-br-md"
              style={{ background: active ? '#facc15' : 'rgba(0,0,0,0.65)', color: active ? '#111' : '#fff' }}
            >
              {name}
            </span>
          </div>
        );
      })}
      {frameRect ? (
        <div
          className="pointer-events-none"
          style={{ ...boxStyle(frameRect), border: '2px solid #38bdf8', boxShadow: '0 0 0 9999px rgba(0,0,0,0.35)' }}
          data-testid="character-map-frame"
        />
      ) : null}
    </div>
  );
}

export default CharacterMapOverlay;
